export const NoteSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        d="M30.293 6.66797H13.6263C11.7854 6.66797 10.293 8.16035 10.293 10.0013V31.668C10.293 33.5089 11.7854 35.0013 13.6263 35.0013H30.293C32.1339 35.0013 33.6263 33.5089 33.6263 31.668V10.0013C33.6263 8.16035 32.1339 6.66797 30.293 6.66797Z"
        stroke="#6853BC"
        stroke-width="2"
      />
      <path
        d="M16.9597 15H26.9597M16.9597 21.6667H26.9597M16.9597 28.3333H23.6264"
        stroke="#6853BC"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const BikeSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <g clip-path="url(#clip0_15337_42501)">
        <path
          d="M10.293 34.1667C8.74595 34.1667 7.26222 33.5521 6.16826 32.4581C5.0743 31.3642 4.45972 29.8804 4.45972 28.3333C4.45972 26.7862 5.0743 25.3025 6.16826 24.2085C7.26222 23.1146 8.74595 22.5 10.293 22.5C11.8401 22.5 13.3239 23.1146 14.4178 24.2085C15.5118 25.3025 16.1264 26.7862 16.1264 28.3333C16.1264 29.8804 15.5118 31.3642 14.4178 32.4581C13.3239 33.5521 11.8401 34.1667 10.293 34.1667ZM10.293 20C8.08291 20 5.9633 20.878 4.40049 22.4408C2.83769 24.0036 1.95972 26.1232 1.95972 28.3333C1.95972 30.5435 2.83769 32.6631 4.40049 34.2259C5.9633 35.7887 8.08291 36.6667 10.293 36.6667C12.5032 36.6667 14.6228 35.7887 16.1856 34.2259C17.7484 32.6631 18.6264 30.5435 18.6264 28.3333C18.6264 26.1232 17.7484 24.0036 16.1856 22.4408C14.6228 20.878 12.5032 20 10.293 20ZM26.6264 16.6667H33.6264V13.6667H28.2931L25.0597 8.21667C24.5764 7.38333 23.6264 6.83333 22.6264 6.83333C21.843 6.83333 21.1264 7.15 20.6264 7.66667L14.4597 13.8167C13.943 14.3333 13.6264 15 13.6264 15.8333C13.6264 16.8833 14.1764 17.7667 15.043 18.2833L20.6264 21.6667V30H23.6264V19.1667L19.8764 16.4167L23.743 12.5M33.6264 34.1667C32.0793 34.1667 30.5956 33.5521 29.5016 32.4581C28.4076 31.3642 27.793 29.8804 27.793 28.3333C27.793 26.7862 28.4076 25.3025 29.5016 24.2085C30.5956 23.1146 32.0793 22.5 33.6264 22.5C35.1735 22.5 36.6572 23.1146 37.7512 24.2085C38.8451 25.3025 39.4597 26.7862 39.4597 28.3333C39.4597 29.8804 38.8451 31.3642 37.7512 32.4581C36.6572 33.5521 35.1735 34.1667 33.6264 34.1667ZM33.6264 20C31.4162 20 29.2966 20.878 27.7338 22.4408C26.171 24.0036 25.293 26.1232 25.293 28.3333C25.293 30.5435 26.171 32.6631 27.7338 34.2259C29.2966 35.7887 31.4162 36.6667 33.6264 36.6667C34.7207 36.6667 35.8044 36.4511 36.8154 36.0323C37.8265 35.6135 38.7451 34.9997 39.5189 34.2259C40.2928 33.4521 40.9066 32.5334 41.3254 31.5224C41.7442 30.5113 41.9597 29.4277 41.9597 28.3333C41.9597 27.239 41.7442 26.1554 41.3254 25.1443C40.9066 24.1333 40.2928 23.2146 39.5189 22.4408C38.7451 21.667 37.8265 21.0531 36.8154 20.6343C35.8044 20.2155 34.7207 20 33.6264 20ZM28.6264 8C30.293 8 31.6264 6.66667 31.6264 5C31.6264 3.33333 30.293 2 28.6264 2C26.9597 2 25.6264 3.33333 25.6264 5C25.6264 6.66667 26.9597 8 28.6264 8Z"
          fill="#6853BC"
        />
      </g>
      <defs>
        <clipPath id="clip0_15337_42501">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0.959717 -0.0078125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BoxSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        d="M21.4597 3.33203C21.1264 3.33203 20.793 3.4987 20.4597 3.66536L7.29305 10.9987C6.79305 11.332 6.45972 11.832 6.45972 12.4987V27.4987C6.45972 28.1654 6.79305 28.6654 7.29305 28.9987L20.4597 36.332C20.793 36.4987 21.1264 36.6654 21.4597 36.6654C21.7931 36.6654 22.1264 36.4987 22.4597 36.332L23.9597 35.4987C23.4597 34.4987 23.2931 33.332 23.1264 32.1654V20.9987L33.1264 15.332V21.6654C34.2931 21.6654 35.4597 21.832 36.4597 22.1654V12.4987C36.4597 11.832 36.1264 11.332 35.6264 10.9987L22.4597 3.66536C22.1264 3.4987 21.7931 3.33203 21.4597 3.33203ZM21.4597 6.9987L31.4597 12.4987L28.1264 14.332L18.2931 8.66536L21.4597 6.9987ZM14.9597 10.4987L24.7931 16.332L21.4597 18.1654L11.4597 12.4987L14.9597 10.4987ZM9.79305 15.332L19.7931 20.9987V32.1654L9.79305 26.4987V15.332ZM36.9597 26.332L30.9597 32.332L28.2931 29.6654L26.4597 31.6654L31.1264 36.6654L39.1264 28.6654L36.9597 26.332Z"
        fill="#6853BC"
      />
    </svg>
  );
};
export const ArrowSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="6"
      viewBox="0 0 108 6"
      fill="none"
    >
      <path
        d="M107.5 3L102.5 0.113249V5.88675L107.5 3ZM0.5 3.5H1.49074V2.5H0.5V3.5ZM3.47222 3.5H5.4537V2.5H3.47222V3.5ZM7.43518 3.5H9.41667V2.5H7.43518V3.5ZM11.3981 3.5H13.3796V2.5H11.3981V3.5ZM15.3611 3.5H17.3426V2.5H15.3611V3.5ZM19.3241 3.5H21.3056V2.5H19.3241V3.5ZM23.287 3.5H25.2685V2.5H23.287V3.5ZM27.25 3.5H29.2315V2.5H27.25V3.5ZM31.213 3.5H33.1944V2.5H31.213V3.5ZM35.1759 3.5H37.1574V2.5H35.1759V3.5ZM39.1389 3.5H41.1204V2.5H39.1389V3.5ZM43.1018 3.5H45.0833V2.5H43.1018V3.5ZM47.0648 3.5H49.0463V2.5H47.0648V3.5ZM51.0278 3.5H53.0092V2.5H51.0278V3.5ZM54.9907 3.5H56.9722V2.5H54.9907V3.5ZM58.9537 3.5H60.9352V2.5H58.9537V3.5ZM62.9166 3.5H64.8981V2.5H62.9166V3.5ZM66.8796 3.5H68.8611V2.5H66.8796V3.5ZM70.8426 3.5H72.8241V2.5H70.8426V3.5ZM74.8055 3.5H76.787V2.5H74.8055V3.5ZM78.7685 3.5H80.75V2.5H78.7685V3.5ZM82.7315 3.5H84.713V2.5H82.7315V3.5ZM86.6944 3.5H88.6759V2.5H86.6944V3.5ZM90.6574 3.5H92.6389V2.5H90.6574V3.5ZM94.6204 3.5H96.6019V2.5H94.6204V3.5ZM98.5833 3.5H100.565V2.5H98.5833V3.5ZM102.546 3.5H104.528V2.5H102.546V3.5Z"
        fill="#1D242D"
      />
    </svg>
  );
};
